<template>
  <div class="container px-5 py-24 mx-auto">
    <SectionHeader sectionTitle="My skills" sectionSubTitle="" />

    <div class="flex flex-wrap -m-4 text-center">
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div
          class="border-2 border-gray-200 px-4 py-14 rounded-lg bg-white
        transition duration-500 ease-in-out transform hover:-translate-y-2 hover:scale-110 hover:border-indigo-500"
        >
          <svg
            fill="#6366F1"
            class="w-12 h-12 mb-3 inline-block"
            viewBox="0 0 640 512"
          >
            <path
              d="M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
            />
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">
            Agile
          </h2>
        </div>
      </div>
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div
          class="border-2 border-gray-200 px-4 py-14 rounded-lg bg-white 
          transition duration-500 ease-in-out transform hover:-translate-y-2 hover:scale-110 hover:border-indigo-500"
        >
          <svg
            fill="#6366F1"
            class="w-12 h-12 mb-3 inline-block"
            viewBox="0 0 640 512"
          >
            <path
              d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
            />
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">
            User Experience
          </h2>
        </div>
      </div>
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div
          class="border-2 border-gray-200 px-4 py-14 rounded-lg bg-white
        transition duration-500 ease-in-out transform hover:-translate-y-2 hover:scale-110 hover:border-indigo-500"
        >
          <svg
            fill="#6366F1"
            class="w-12 h-12 mb-3 inline-block"
            viewBox="0 0 20 20"
          >
            <path
              d="M18 16h2v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1h2V4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v12zM4 4v9h12V4H4zm4 11v1h4v-1H8z"
            />
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">
            Front End
          </h2>
        </div>
      </div>
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div
          class="border-2 border-gray-200 px-4 py-14 rounded-lg bg-white 
          transition duration-500 ease-in-out transform hover:-translate-y-2 hover:scale-110 hover:border-indigo-500"
        >
          <svg
            fill="#6366F1"
            class="w-12 h-12 mb-3 inline-block"
            viewBox="0 0 640 512"
          >
            <path
              d="M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
            />
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">Backend</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/components/SectionHeader";

export default {
  name: "Skills",
  components: { SectionHeader },
  data: () => ({
    //
  })
};
</script>
